module.exports = __webpack_public_path__ + "img/h13.721b4508.png";